import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {MenuItem} from "primeng/api";

@Component({
  selector: 'app-top-filter',
  templateUrl: './top-filter.component.html',
  styleUrls: ['./top-filter.component.css']
})
export class TopFilterComponent {

  @Input() products: any[] = [];
  @Output() selectedFilter = new EventEmitter<ElementRef>();
  sidebarFilter: boolean = false;

  filters: any = {
    Brands: ['Realme', 'Samsung', 'Xiaomi', 'Oppo', 'Vivo', 'Tecno', 'Apple'],
    Colors: ['Black', 'Green', 'Lime Green', 'Glittey White', 'Startail Black'],
    Storage: ['64GB', '128GB', '256GB', '512GB', '1TB'],
    RAM: ['4GB', '6GB', '8GB', '16GB', '32GB'],
    Price_Range: ['Below ₹10000', '₹10000 - ₹20000', '₹20000 - ₹50000', '₹50000 - ₹100000', 'Above ₹100000'],
    Discounts: ['10%', '20%', '30%', '40%', 'Above 50%'],
    Display_Type: ['AMOLED', 'LCD', 'OLED'],
    Display_Size: ['5.5"', '6.1"', '6.7"', 'Above 6.7"'],
    Battery_Size: ['3000mAh', '4000mAh', '5000mAh', 'Above 5000mAh'],
    Processors: ['Snapdragon', 'MediaTek', 'Exynos', 'Apple', 'Other']
  };

  selectedFilters: any = {};

  toggleFilter(category: string, value: string, priceSort: boolean = false) {
    let selected = this.selectedFilters[category];
    if (!selected) selected = this.selectedFilters[category] = [];
    if (selected.includes(value)) {
      this.selectedFilters[category] = selected.filter((item: string) => item !== value);
    } else {
      if (priceSort) {
        this.selectedFilters[category] = value;
        this.applyFilters();
      } else {
        this.selectedFilters[category].push(value);
      }
    }
  }

  applyFilters() {
    this.sidebarFilter = false;
    this.selectedFilter.emit(this.selectedFilters);
  }

}
